import React, { FC } from "react";

import "./_animated-progress-bar.scss";

interface IAnimatedProgressBarProps {
  progress: number;
}

export const AnimatedProgressBar: FC<IAnimatedProgressBarProps> = ({ progress }) => {
  const baseClass = "animated-progress-bar";

  return (
    <div className={baseClass}>
      <div className={`${baseClass}__indicator`} style={{ width: `${progress}%` }}>
        <div className={`${baseClass}__indicator-color`} />
      </div>
    </div>
  );
};
